import python from "../../assets/images/python.png";
import c from "../../assets/images/letter-c.png";
import cplus from "../../assets/images/c-.png";
import java from "../../assets/images/java.png";
import html from "../../assets/images/html.png";
import css from "../../assets/images/css-3.png";
import js from "../../assets/images/js.png";
import ract from "../../assets/images/atom.png";
import node from "../../assets/images/nodejs.png";
import boot from "../../assets/images/bootstrap.png";
import sql from "../../assets/images/logo.svg";
import tailwind from "../../assets/images/tailwind.png";
import firebase from "../../assets/images/firebase.jpg";
import csharp from "../../assets/images/csharp.png";

const skills_list = [
  { name: "Python", link: python },
  { name: "C", link: c },
  { name: "C#", link: csharp },
  { name: "C++", link: cplus },
  { name: "Java", link: java },
  { name: "HTML", link: html },
  { name: "CSS", link: css },
  { name: "JavaScript", link: js },
  { name: "React", link: ract },
  { name: "NodeJS", link: node },
  { name: "Bootstrap", link: boot },
  { name: "SQL", link: sql },
  { name: "TailwindCSS", link: tailwind },
  { name: "Firebase", link: firebase },
];

export default skills_list;
